var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.762 12-6.461-6-1.032 1.111 4.448 4.13H5v1.517h11.717l-4.448 4.13L13.3 18l6.461-6Z",
    fill: "currentColor"
  })));
};
export { SvgArrowRight as ReactComponent };
export default __webpack_public_path__ + "553bda6d1f189291915eee2b725767ce.svg";